import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = []

  connect() {
    this.onToggle = this.handleToggle.bind(this)
    this.element.addEventListener('toggle', this.onToggle)
  }

  disconnect() {
    this.element.removeEventListener('toggle', this.onToggle)
  }

  handleToggle(event) {
    // Only proceed if this dropdown is being opened
    if (this.element.open) {
      this.closeOtherDropdowns()
    }
  }

  closeOtherDropdowns() {
    // Find all other details elements with the dropdown class
    const allDropdowns = document.querySelectorAll('details.dropdown')

    allDropdowns.forEach(dropdown => {
      // Close all other dropdowns except this one
      if (dropdown !== this.element && dropdown.open) {
        dropdown.removeAttribute('open')
      }
    })
  }
}
